export const contactEs = {
  embed: {
    infoTitle: 'Información de contacto',
    phone: 'Teléfono',
    email: 'Email',
    scheduleTitle: 'Horario de atención',
    scheduleWeekdays: 'Lunes a Viernes: 9:00 - 18:00',
    scheduleSaturday: 'Sábado: 10:00 - 14:00',
  },
};
